// src/router.js
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/Index.vue'; 
import Home from '@/views/home/Home.vue';

// 图片路由
import tupian from '@/views/tupian/Index.vue';
// 头像图片管理
import pics from '@/views/tupian/touxiang.vue';
// 菜品图片
import userdeshespic from '@/views/tupian/caipin.vue';
//发布通知
import tongzhi from '@/views/fabutongzhi/Index.vue';

//菜品图库
import dishgallery from '@/views/dishgallery/Index.vue';
// 获取用户信息
import user from '@/views/user/Index.vue'
// 菜品操作日志
import OperationLogs from '@/views/operationLogs/Index.vue';
//菜品管理
import DishManagement  from '@/views/DishManagement/Index.vue';
//串门访问管理
import Visituser  from '@/views/visituser/Index.vue';
// 爱心兑换鱼管理
import fish  from '@/views/fish/Index.vue';


Vue.use(Router);

const routes = [
    {
        path: '/',
        component: Layout,
        children:[
            {
                path:'/',
                name:'home',
                component: Home
            },
             {
                path: '/tupian', // 图片管理页面
                name: 'tupian', 
                component: tupian,
            },
            {
                path: '/pics', // 图片头像
                name: 'pics', 
                component: pics,
            },
            {
                path: '/userdeshespic', // 图片管理页面
                name: 'userdeshespic', 
                component: userdeshespic,
            },
            {
                path: '/tongzhi', // 发布通知
                name: 'tongzhi', 
                component: tongzhi,
            },
            {
                path: '/dishgallery', // 发放爱心
                name: 'dishgallery', 
                component: dishgallery,
            },
            {
                path: '/user', // 用户管理
                name: 'user', 
                component: user,
            },
            {
                path: '/operation-logs', // 操作日志
                name: 'OperationLogs', 
                component: OperationLogs,
                meta: { title: '操作日志管理' }
            },
            {   
                path: '/DishManagement', // 菜品管理
                name: 'DishManagement', 
                component: DishManagement,
                meta: { title: '菜品管理' }
                
            }, {   
                path: '/Visituser', // 串门访问管理
                name: 'Visituser', 
                component: Visituser,
                meta: { title: '串门访问管理' }
                
            },
            {
                path: '/fish', // 爱心兑换鱼管理
                name: 'fish',
                component: fish,
                meta: { title: '爱心兑换鱼管理' }
            }
        ]
    },
];

const router = new Router({
    mode: 'history', // 使用历史模式，URL中不会带有#
    routes,
});

export default router;